module.exports = __webpack_public_path__ + "static/media/error.0b1e37d9.svg";